module.exports = __webpack_public_path__ + "img/popularity-unchecked-in.1f3f3bef.png";